module.exports = __webpack_public_path__ + "img/ico_archive_active.3b61e440.svg";